import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const TemporaryChatIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "TemporaryChat",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.74 25.39c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l1.77-1.77c.21-.21.51-.33.81-.33h2.5a1.14 1.14 0 1 1 0 2.28H9.98l-1.43 1.43c-.22.22-.52.33-.81.33ZM2.29 30.84c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06v-2.5a1.14 1.14 0 0 1 2.26-.21c.45-.31 1.06-.26 1.45.14.45.45.45 1.17 0 1.62l-1.77 1.77c-.22.22-.51.33-.81.33ZM2.29 24.27c-.63 0-1.14-.51-1.14-1.14v-5.09a1.14 1.14 0 1 1 2.28 0v5.09c0 .63-.51 1.14-1.14 1.14m24.54-.65h-1.56a1.14 1.14 0 1 1 0-2.28h1.56c.73 0 1.39-.46 1.64-1.15a1.145 1.145 0 1 1 2.15.79 4.05 4.05 0 0 1-3.79 2.65Zm-5.64 0H16.1a1.14 1.14 0 1 1 0-2.28h5.09a1.14 1.14 0 1 1 0 2.28m8.52-5.95c-.63 0-1.14-.51-1.14-1.14v-5.09a1.14 1.14 0 1 1 2.28 0v5.09c0 .63-.51 1.14-1.14 1.14M2.29 15.1c-.63 0-1.14-.51-1.14-1.14V8.87a1.14 1.14 0 1 1 2.28 0v5.09c0 .63-.51 1.14-1.14 1.14m27.42-6.59c-.63 0-1.14-.51-1.14-1.14V5.16c0-.59-.3-1.14-.8-1.47-.53-.34-.68-1.05-.34-1.58s1.05-.68 1.58-.34c1.15.75 1.84 2.01 1.84 3.38v2.21c0 .63-.51 1.14-1.14 1.14ZM2.31 5.94h-.14a1.14 1.14 0 0 1-.99-1.28 4.04 4.04 0 0 1 4-3.53h.91a1.14 1.14 0 1 1 0 2.28h-.91c-.88 0-1.62.66-1.73 1.53-.07.58-.56 1-1.13 1Zm22.1-2.53h-5.09a1.14 1.14 0 1 1 0-2.28h5.09a1.14 1.14 0 1 1 0 2.28m-9.16 0h-5.09a1.14 1.14 0 1 1 0-2.28h5.09a1.14 1.14 0 1 1 0 2.28"
    })
  }));
};